// libs
import React from 'react';

// components
import { Box } from '@lyearn/ui';

import { MessageItemContext } from '../context';
import { Message } from '../types';

type Props = {
  children: React.ReactNode;
  className?: string;
  message: Message;
};

const MessageItem: React.FC<Props> = (props) => {
  const { message, className, children } = props;

  return (
    <MessageItemContext.Provider value={message}>
      <Box className={className}>{children}</Box>
    </MessageItemContext.Provider>
  );
};

export default MessageItem;
